// ABOUTME: Displays child family members grid with add functionality
// ABOUTME: Shows avatar, name, age, and joined date for each child

import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import type { FamilyDetailData } from './types';

interface ChildrenSectionProps {
  family: FamilyDetailData;
  calculateAge: (birthDate: string) => number | string;
  formatDate: (dateString: string) => string;
  onAddChild: () => void;
  onChildClick: (childId: number) => void;
}

const ChildrenSection: React.FC<ChildrenSectionProps> = ({
  family,
  calculateAge,
  formatDate,
  onAddChild,
  onChildClick
}) => {
  return (
    <Card sx={{ mb: 3 }} data-testid="children-section">
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">
            Children ({family.children.length})
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddChild}
          >
            Add Child
          </Button>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
          {family.children.map((child) => (
            <Card
              key={child.id}
              variant="outlined"
              sx={{ cursor: 'pointer' }}
              onClick={() => onChildClick(child.id)}
              data-testid={`child-card-${child.id}`}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Avatar src={child.avatarUrl} sx={{ mr: 2 }}>
                    {child.firstName[0]}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2" fontWeight="medium">
                      {child.firstName} {child.lastName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Age: {calculateAge(child.birthDate)}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="caption" color="text.secondary">
                  Joined: {formatDate(child.joinedAt)}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChildrenSection;
